/** Append start/end date query params as inclusive local full days (00:00 → 23:59:59.999). */
export const appendInclusiveDateRange = (params, startDate, endDate) => {
    if (startDate) params.append('startDate', `${startDate}T00:00:00`);
    if (endDate) params.append('endDate', `${endDate}T23:59:59.999`);
};
